import localforage from 'localforage'
import { Parser as HtmlToReactParser } from 'html-to-react'
import * as R from 'ramda'

const htmlToReactParser = new HtmlToReactParser()

export function unescapeHtmlTags(input) {
    // console.log(input)
    // input = input.replace(/&amp;iquest&#x3b;/g, "&iquest;")
    // input = input.replace(/&amp;oacute&#x3b;/g, "&oacute;")
    // input = input.replace(/&amp;iacute&#x3b;/g, "&iacute;")
    // input = input.replace(/&amp;eacute&#x3b;/g, "&eacute;")
    // input = input.replace(/&amp;nbsp&#x3b;/g, " ")
    // input = input.replace(/&amp;rsquo;/g, "'")
    input = input.replace(/&amp;&#x23;39&#x3b;/g, "'")
    input = input.replace(/&amp;&#x23;39;/g, "'")
    input = input.replace(/&amp;/g, '&')
    input = input.replace(/&gt;/g, '>')
    input = input.replace(/&lt;/g, '<')
    input = input.replace(/&gt;/g, '>')
    input = input.replace(/&lt;/g, '<')
    input = input.replace(/&#x2f;/g, '/')
    input = input.replace(/&#x3d;/g, '=')
    input = input.replace(/&quot;/g, '"')
    input = input.replace(/&#x3a;/g, ':')
    input = input.replace(/&#x3b;/g, ';')
    input = input.replace(/&#xa;/g, '')// line feed
    input = input.replace(/&#x9;/g, '')// carriage retrn
    input = input.replace(/&#x40;/g, '@')
    input = input.replace(/&#x21;/g, '!')
    input = input.replace(/&#163;/g, '£')
    input = input.replace(/&#x3f;/g, '?')
    input = input.replace(/&#39;/g, "'")
    input = input.replace(/&#x27;/g, "'")
    input = input.replace(/&#x28;/g, '(')
    input = input.replace(/&#x29;/g, ')')
    // console.log(input)
    return input
}

export function parseHtmlForReact(input, asSpan = true) {
    let c
    try {
        c = htmlToReactParser.parse(asSpan ? `<span>${unescapeHtmlTags(input)}</span>` : unescapeHtmlTags(input))
    } catch (e) {
        c = htmlToReactParser.parse(asSpan ? `<span>${unescapeHtmlTags(stripOutHtml(input))}</span>` : unescapeHtmlTags(stripOutHtml(input)))
    }
    return c
}

export function stripOutHtml(input) {
    // thanks to https://robertnyman.com/roblab/javascript-remove-tags.htm
    // console.log(input)
    const strInputCode = input.replace(/&(lt|gt);/g, (strMatch, p1) => ((p1 == 'lt') ? '<' : '>'))
    return strInputCode.replace(/<\/?[^>]+(>|$)/g, '')
}

export function localStorageSupported() {
    return localforage.supports(localforage.INDEXEDDB) || localforage.supports(localforage.WEBSQL) || localforage.supports(localforage.LOCALSTORAGE)
}

export function getRuntimeEnvironment() {
    /*
    if(window.location.hostname.indexOf("dev") !== -1 || window.location.hostname.indexOf("localhost") !== -1){
        return "dev-"
    } else {
        return ""
    }
    */

    // remove above once all environments set up
    const hName = window.location.hostname
    const arrNames = hName.split('.')
    if (arrNames.length === 1) {
        return 'dev-'
    }
    const subDomain = arrNames[0]
    const arrSDomains = subDomain.split('-')
    if (arrSDomains.length === 2) {
        return `${arrSDomains[0]}-`
    }
    return ''
}

export function sort(curr, return_new, lang_code) {
    const array = return_new ? curr.reduce((arr, a) => { arr.push(a); return arr }, []) : curr
    console.log(`sort alpha ${lang_code}`)
    return array.sort((a, b) => {
        let value = 0
        if (a.get('langs')[lang_code].text < b.get('langs')[lang_code].text) {
            value = -1
        } else if (a.get('langs')[lang_code].text > b.get('langs')[lang_code].text) {
            value = 1
        }
        return value
    })
}

// borrowed this from http://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
export function shuffle(current_array, new_array) {
    const array = new_array ? current_array.reduce((arr, a) => { arr.push(a); return arr }, []) : current_array

    let currentIndex = array.length; let temporaryValue; let
        randomIndex
    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1
        // And swap it with the current element.
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
    }
    return array
}

export function makeIterator(array) {
    let nextIndex = 0

    return {
        next() {
            return nextIndex < array.length
                ? { value: array[nextIndex++], done: false }
                : { done: true }
        },

        hasNext() {
            return nextIndex < array.length
        },
    }
}

export function decodeToken(token) {
    console.log(token)
    return ''// jwtDecode(token);
}

export function tokenIsValid(token) {
    console.log(token)
    return true
}

export function friendlyDateFormat(date) {
    const dateFormat = require('dateformat')
    return dateFormat(date, 'dddd, mmmm dS, yyyy, h:MM:ss TT')
}

export function tmpSwapOutOtherQuestions(data) {
    const newData = {}
    const arrPages = data.pages
    arrPages.forEach((page) => {
        if (page.hasOwnProperty('questions')) {
            const arrQuestions = page.questions
            arrQuestions.forEach((question) => {
                if (question.hasOwnProperty('sets')) {
                    const arrSets = question.sets
                    arrSets.forEach((set) => {
                        if (set.hasOwnProperty('options')) {
                            const arrOptions = set.options
                            arrOptions.forEach((option) => {
                                if (option.hasOwnProperty('question')) {
                                    const other = option.question
                                    // delete(option.question)
                                    delete (other.id)
                                    delete (other.type)
                                    option.other = other
                                }
                            })
                        }
                    })
                }
            })
        }
    })
    // console.log(JSON.stringify(data))
    return data
}

export function reorder(list, startIndex, endIndex) {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
}

/**
 * @param {any} value               - value to be used
 * @param {object} object           - object to be updated
 * @param {string} property         - property of object to be updated
 */
export const selectUpdater = (value, object, property) => {
    const objRef = object
    objRef[property] = value
    return objRef
}

export const guidGenerator = () => {
    const S4 = function () {
        return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1)
    }
    return (`e${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`)
}

export const isEmpty = (value) => value === undefined || value === null || (typeof value === 'object' && Object.keys(value).length === 0) || (typeof value === 'string' && value.trim().length === 0)

export const sortByNameCaseInsensitive = R.sortBy(R.compose(R.toLower, R.prop('label')))

export const hasRequiredDependencies = (
    kpi,
    allowedKpiQuestions = new Set(),
    allowedKpis = new Set(),
) => {
    const numberOfRequiredDependencies = R.pathOr(0, ['minQlistQuestions'], kpi)
    return R.pathOr([], ['dependencies'], kpi).filter(({ dependencyType, id }) => (
        dependencyType === 'kpi'
            ? allowedKpis.has(id.toLowerCase())
            : allowedKpiQuestions.has(id.toLowerCase())
    )).length >= numberOfRequiredDependencies
}
